export default {
    header: "Zamówienia {name}",
    error: "Wystąpił błąd",
    empty: "Nie znaleziono zamówień",
    system: "Biuro pomocy",
    orders: {
        name: "Nazwa",
        date: "Data",
        status: "Status",
        approvedBy: "Zatwierdzone przez"
    },
    cta: {
        close: "Zamknąć"
    }
}